// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart__restaurant-btn-rank,
.checkout__restaurant-btn-rank {
  font-weight: 600;
  color: #8b7355;
}

.cart__restaurant-sort-hint,
.checkout__restaurant-sort-hint {
  margin: 0 0 12px;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  line-height: 1.35;
  color: #6b5c56;
}

.checkout__restaurant-hint {
  margin: 0 0 8px;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  line-height: 1.35;
  color: #6b5c56;
}
`, "",{"version":3,"sources":["webpack://./src/components/DeliveryRestaurantPicker.css"],"names":[],"mappings":"AAAA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".cart__restaurant-btn-rank,\n.checkout__restaurant-btn-rank {\n  font-weight: 600;\n  color: #8b7355;\n}\n\n.cart__restaurant-sort-hint,\n.checkout__restaurant-sort-hint {\n  margin: 0 0 12px;\n  font-family: 'Roboto', sans-serif;\n  font-size: 13px;\n  line-height: 1.35;\n  color: #6b5c56;\n}\n\n.checkout__restaurant-hint {\n  margin: 0 0 8px;\n  font-family: 'Roboto', sans-serif;\n  font-size: 13px;\n  line-height: 1.35;\n  color: #6b5c56;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
